import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import thunkMiddleware from "redux-thunk";
import { USER_LOGOUT } from "./auth/login/actionTypes";
import rootReducer from "./reducers";
import rootSaga from "./sagas";

const sagaMiddleware = createSagaMiddleware();
const middlewares = [thunkMiddleware, sagaMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Retrieve any previous state from localStorage
const persistedState = (() => {
  try {
    const state = localStorage.getItem("reduxState");
    return state ? JSON.parse(state) : {};
  } catch (e) {
    console.warn("Error parsing localStorage:", e);
    return {};
  }
})();

const appReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    localStorage.clear();
    state = undefined;
    localStorage.removeItem("reduxState")
  }
  return rootReducer(state, action);
};

export function configureStore() {
  const store = createStore(
    appReducer,
    persistedState, // Use previous state from localStorage, if any
    composeEnhancers(applyMiddleware(...middlewares))
  );

  // Save the state to localStorage on any change
  store.subscribe(() => {
    localStorage.setItem("reduxState", JSON.stringify(store.getState()));
  });

  sagaMiddleware.run(rootSaga);

  // if (!store.getState().token && typeof store.getState().token === "undefined") {
  //   window.location.href = "/login"; // Redirect to login page
  // }

  return store;
}
